// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3j25W","stretch":"RGrEv"};